module.exports = __webpack_public_path__ + "static/img/1.b9afd6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/12/sp/1.png
// module id = Hf7T
// module chunks = 0